import { render, staticRenderFns } from "./ManageBillToCompanies.vue?vue&type=template&id=01f9467d"
import script from "./ManageBillToCompanies.vue?vue&type=script&lang=ts"
export * from "./ManageBillToCompanies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports